<script lang="ts">
    import Fa from 'svelte-fa'
    import { faFileArrowUp, faPaperclip } from '@fortawesome/free-solid-svg-icons'

    export let data: Record<string, any>
</script>

<div class="block-preview">
    <Fa icon={faFileArrowUp} />
    <span>Upload de arquivos (PDF, Word, Excel, imagens...) — sem prévia, só lista para download</span>
    <Fa icon={faPaperclip} class="clip-icon" />
</div>

<style>
    .block-preview {
        max-width: 460px;
        height: 64px;
        border: 1px dashed #c7cdd4;
        border-radius: 8px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        gap: 10px;
        color: #868e96;
        font-size: 0.82rem;
        padding: 0 16px;
    }
    :global(.clip-icon) {
        opacity: 0.6;
    }
</style>
